import { conatinerIprops } from "./addpartinterface";
import AddPartNumber from "./addpartnumber"
import React from 'react';

const AddPartNumberContainer = (props: conatinerIprops) => {

    return (
        <AddPartNumber
            isRefreshing={props?.isRefreshing}
            setIsPriceAndAvailabilityRequired={props.setIsPriceAndAvailabilityRequired}
            cartsDetails={props.cartsDetails}
            getCartItems={props.getCartItems}
            manufactureOption={props.manufactureOption}
            onRefresh={props.onRefresh}
            cartToolMenu={props.cartToolMenu}
            onHandlePartNo={props.onHandlePartNo}
            isPartNumber={props.isPartNumber}
            setRefreshCartRequiredParts={props?.setRefreshCartRequiredParts}
            getMiningParts={props?.getMiningParts}
            getAdminFlag={props.getAdminFlag}
            refreshCartRequiredParts={props?.refreshCartRequiredParts} />
    )
}
export default AddPartNumberContainer